/**
 * @license EUPL-1.2
 * Copyright (c) 2020-2024 Frameless B.V.
 * Copyright (c) 2021-2024 Gemeente Utrecht
 */

@use "~@utrecht/code-css/src" as *;

:host {
  display: inline;
}

:host([hidden]) {
  display: none !important;
}
